import { Flex, Button } from '@mantine/core';
import { CONTENTFUL_ENGLISH_KEY, ContentfulProductType } from '@web/common';
import { useProductsStore } from './ProductsStore';
import { observer } from 'mobx-react';

export const ProductFilterButtons = observer(() => {
  const store = useProductsStore();

  function getProductCountByType(type: ContentfulProductType) {
    return store.products?.filter(
      (product) => product.fields.type[CONTENTFUL_ENGLISH_KEY] === type,
    ).length;
  }

  return (
    <Flex gap="8px" m="auto" wrap="wrap" justify="center">
      {Object.values(ContentfulProductType).map((type) => (
        <Button
          key={type}
          variant={store.selectedProductType === type ? 'filled' : 'outline'}
          onClick={() => store.setSelectedProductType(type)}
        >
          {type} ({getProductCountByType(type)})
        </Button>
      ))}
    </Flex>
  );
});
